<script>
import auctionVesselPanel from "../components/auctionVesselPanel";

export default {
  name: "auction-vessels",
  components: {
    auctionVesselPanel,
  },
  props: {
    refreshBidList: Number,
    showFuel: Boolean,
    refreshChat: Number,
  },
  data: function() {
    return {};
  },
  methods: {
    onSetActiveVessel: function(bid, vesselName) {
      this.$store.commit("setActiveBid", bid);
      this.$store.commit("setActiveVesselName", vesselName);
    },
    onClick: function() {
      if (this.$store.state.activeBid) {
        this.$store.commit("setActiveBid", null);
        this.$store.commit("setActiveVesselName", null);
      }
    },
    onKeyup: function(e) {
      if (e.keyCode == 27 && this.$store.state.activeBid) {
        this.$store.commit("setActiveBid", null);
        this.$store.commit("setActiveVesselName", null);
      }
    },
    getEstimatedDailyFuelCost(b) {
      var ecoSpeedConsumption = b.offer.Vessel.mac_fue_economicSpeedFuel;
      var rate = this.fuelPrice;
      var unit = this.fuelUnit;
      return getEstimatedDailyFuelCost(ecoSpeedConsumption, rate, unit);
    },
    getTotalEstimatedRate(b) {
      var fuelCostDaily = this.getEstimatedDailyFuelCost(b);
      if (!fuelCostDaily) {
        return null;
      } else {
        return fuelCostDaily + b.currentRate;
      }
    },
  },
  computed: {
    bids: function() {
      var self = this;
      if (!self.showFuel || !self.$store.state.activeAuction.includeFuelCost) {
        return self.$store.state.activeAuction.bids;
      } else {
        var bids = [...self.$store.state.activeAuction.bids];
        return bids.sort(function(objA, objB) {
          var estA = self.getTotalEstimatedRate(objA);
          var estB = self.getTotalEstimatedRate(objB);
          if (estA && estB) {
            return estA - estB;
          } else if (estA) {
            return -1;
          } else if (estB) {
            return 1;
          } else {
            return objA.currentRate - objB.currentRate;
          }
        });
      }
    },
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    auctionCurrency: function() {
      return this.$store.state.activeAuction.currency;
    },
    fuelPrice() {
      return this.$store.state.fuelPrice;
    },
    fuelUnit() {
      return this.$store.state.fuelUnit;
    },
    userRole: function() {
      return this.$store.state.role;
    },
    isCharterer: function() {
      return this.userRole == "CHA";
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  mounted: function() {
    if (!this.isOwner) {
      document.addEventListener("click", this.onClick);
      document.addEventListener("keyup", this.onKeyup);
    }

    if (this.isOwner) {
      this.$store.commit("setActiveBid", this.bids[0]);
      this.$store.commit("setActiveVesselName", this.bids[0].vesselName);
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("click", this.onClick);
    document.removeEventListener("keyup", this.onKeyup);
  },
  watch: {},
};
</script>
<template>
  <div class="content-bordered vessel-list-wrapper">
    <transition-group name="flip-list" tag="div">
      <div v-for="item in bids" :key="`row-${item.offerId}`" v-on:click.stop="onSetActiveVessel(item, item.vesselName)" class="vessel-panel">
        <auction-vessel-panel :refreshChat="refreshChat" :bid="item" :showFuelCost="showFuel"></auction-vessel-panel>
      </div>
    </transition-group>
  </div>
</template>
<style scoped>
.vessel-panel {
  -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
}

.flip-list-move {
  transition: transform 0.5s;
}
</style>
